import { render, staticRenderFns } from "./skill-card.vue?vue&type=template&id=73435080&scoped=true&"
import script from "./skill-card.vue?vue&type=script&lang=js&"
export * from "./skill-card.vue?vue&type=script&lang=js&"
import style0 from "./skill-card.vue?vue&type=style&index=0&id=73435080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73435080",
  null
  
)

export default component.exports